export default function ComparisonTable() {
  const rows = [
    { feature: "Ease of Use", gtbuy: 4, kakobuy: 3, superbuy: 5 },
    { feature: "Pricing", gtbuy: "Medium", kakobuy: "Low", superbuy: "High" },
    { feature: "Order Speed", gtbuy: "Fast", kakobuy: "Medium", superbuy: "Fast" },
    { feature: "Beginner Friendly", gtbuy: "Yes", kakobuy: "Medium", superbuy: "Yes" },
    { feature: "Trust Level", gtbuy: "High", kakobuy: "Medium", superbuy: "Very High" },
    { feature: "Spreadsheet Integration", gtbuy: "Excellent", kakobuy: "Good", superbuy: "Excellent" },
  ];

  const renderStars = (count: number) => {
    return (
      <span className="inline-flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((s) => (
          <span key={s} className="w-3.5 h-3.5 flex items-center justify-center">
            <i className={`text-xs ${s <= count ? "ri-star-fill text-accent-400" : "ri-star-line text-foreground-300"}`}></i>
          </span>
        ))}
      </span>
    );
  };

  const renderCell = (val: string | number) => {
    if (typeof val === "number") return renderStars(val);
    return <span className="text-sm text-foreground-700">{val}</span>;
  };

  return (
    <section id="comparison" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-accent-600 uppercase tracking-wide mb-3">Platform Comparison</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            GTBuy Spreadsheet vs Kakobuy vs Superbuy
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Compare the top spreadsheet shopping platforms side by side. Find which one fits your shopping style and budget needs best.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70 bg-white">
          <table className="w-full min-w-[600px]">
            <thead>
              <tr className="border-b border-background-200/70 bg-background-50">
                <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-800">Feature</th>
                <th className="text-center px-5 py-4 text-sm font-semibold text-primary-600">
                  GTBuy Spreadsheet
                </th>
                <th className="text-center px-5 py-4 text-sm font-semibold text-foreground-700">Kakobuy Spreadsheet</th>
                <th className="text-center px-5 py-4 text-sm font-semibold text-foreground-700">Superbuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.feature} className={`border-b border-background-100 ${i % 2 === 0 ? "bg-white" : "bg-background-50/50"}`}>
                  <td className="px-5 py-3.5 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                  <td className="px-5 py-3.5 text-center">{renderCell(row.gtbuy)}</td>
                  <td className="px-5 py-3.5 text-center">{renderCell(row.kakobuy)}</td>
                  <td className="px-5 py-3.5 text-center">{renderCell(row.superbuy)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <div className="p-5 md:p-6 rounded-xl bg-white border border-primary-200/70">
            <h4 className="font-heading text-lg font-semibold text-primary-700 mb-2">Choose GTBuy Spreadsheet if…</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              You want balanced pricing with great ease of use. Ideal for regular spreadsheet shoppers who need reliability without breaking the bank.
            </p>
          </div>
          <div className="p-5 md:p-6 rounded-xl bg-white border border-background-200/70">
            <h4 className="font-heading text-lg font-semibold text-foreground-800 mb-2">Choose Kakobuy Spreadsheet if…</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              You are on a tighter budget and don't mind a slightly steeper learning curve. Best for cost-conscious spreadsheet buyers.
            </p>
          </div>
          <div className="p-5 md:p-6 rounded-xl bg-white border border-background-200/70">
            <h4 className="font-heading text-lg font-semibold text-foreground-800 mb-2">Choose Superbuy Spreadsheet if…</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              You want the most premium, polished experience with top-tier reliability and the fastest order processing available.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}